import { ToucanSortMenu } from "toucan";
import { PERSON_SORT_DOWNWARDS } from "../model.ts";
import type { SortVocabulary } from "toucan";
import type { PersonSort, PersonSortField } from "../model.ts";

/**
 * How Toucan People says its own orders: what each field is called, and what
 * each direction of it reads as.
 *
 * Down is the order you would expect of that field before being told — A at
 * the top of a list of names, and the newest person at the top of a list of
 * dates.
 */
const VOCABULARY: SortVocabulary<PersonSortField> = {
  fields: ["name", "added"],
  labels: {
    name: "Name",
    added: "Date added",
  },
  orders: {
    name: { desc: "Z → A", asc: "A → Z" },
    added: { desc: "newest first", asc: "oldest first" },
  },
  downwards: PERSON_SORT_DOWNWARDS,
};

/** The list's sort control, in People's words. */
export function SortMenu({
  sort,
  onSort,
}: {
  sort: PersonSort;
  onSort: (sort: PersonSort) => void;
}) {
  return <ToucanSortMenu sort={sort} vocabulary={VOCABULARY} onSort={onSort} />;
}
